module.exports = __webpack_public_path__ + "img/fbg.b6059c4f.jpg";